import React from "react";
import './AD.css'
const AD = () => {
  return <div>
    <div class="AD">
    <div class="ADbox">
      <h4>데이트 장소 특가전</h4>
      <div class="middle">
      <h1>퍼펙트딜</h1>
      <h2>최대<br /> 40%</h2>

    </div>
      <h3>#한정수량 #선착순</h3>
      <div class="cellphone">
        <img src="images/13.png" alt="핸드폰" />
      </div>
    </div>
  </div>
  </div>;
};

export default AD;
